import { render, staticRenderFns } from "./prolongations.vue?vue&type=template&id=27420a41&scoped=true"
import script from "./prolongations.vue?vue&type=script&lang=js"
export * from "./prolongations.vue?vue&type=script&lang=js"
import style0 from "./prolongations.vue?vue&type=style&index=0&id=27420a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27420a41",
  null
  
)

export default component.exports